import { BadgesService } from './badges-service';

export default BadgesService;
